export const AUTH_SUCCESS_TOAST_QUERY_KEY = 'authSuccessToast';

export const AUTH_SUCCESS_TOAST_TYPE = {
  LOGIN: 'login',
  SIGNUP: 'signup',
};

const AUTH_SUCCESS_TOAST_TYPES = new Set(
  Object.values(AUTH_SUCCESS_TOAST_TYPE),
);

export const withAuthSuccessToastQuery = (url, type) => {
  if (!url || !AUTH_SUCCESS_TOAST_TYPES.has(type)) {
    return url;
  }

  try {
    const parsedUrl = new URL(url, window.location.origin);
    parsedUrl.searchParams.set(AUTH_SUCCESS_TOAST_QUERY_KEY, type);

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return url;
  }
};

export const reloadWithAuthSuccessToast = (type, url) => {
  window.history.replaceState(
    null,
    '',
    withAuthSuccessToastQuery(url || window.location.href, type),
  );
  window.location.reload();
};

export const consumeAuthSuccessToastFromLocation = () => {
  try {
    const parsedUrl = new URL(window.location.href);
    const type = parsedUrl.searchParams.get(AUTH_SUCCESS_TOAST_QUERY_KEY);

    if (!AUTH_SUCCESS_TOAST_TYPES.has(type)) {
      return null;
    }

    parsedUrl.searchParams.delete(AUTH_SUCCESS_TOAST_QUERY_KEY);
    window.history.replaceState(
      null,
      '',
      `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`,
    );

    return type;
  } catch {
    return null;
  }
};
